





























































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import ActivitySelect from '@/components/activity-select/index.vue'
import PicModal from '@/components/upload/picModal.vue'
@Component({
  components: {
    ActivitySelect,
    PicModal
  }
})
export default class Activity extends Vue {
  @Prop({
    type: Boolean,
    default: () => false
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'activity',
        // limitDiscount 限时折扣 preSales 预售 group 拼团 secKill 秒杀 buyGetOne 满x件免一 tierDiscount 满减满折 freeShipping 满包邮
        activityType: 'limitDiscount',
        activityId: null,
        activityTitle: null,
        maxNumber: 6,
        cornerMark: null,
        title: '',
        // 0 1 2 三种样式
        styleType: 0,
        // 仅样式三生效
        rowNmuber: 3,
        isMore: true,
        titleConfig: {
          // text、img
          type: 'text',
          title: '',
          imgUrl: '',
          style: {
            backgroundColor: '#ffffff',
            color: '#000000'
          }
        }
      }
    }
  })
  ActivityConfig!: any

  showGoodsIndex = -1

  get showImg() {
    let img = ''
    switch (this.ActivityConfig.styleType) {
      case 0:
        img = require('@/assets/images/goodStyle-1.jpg')
        break
      case 1:
        img = require('@/assets/images/goodStyle-2.jpg')
        break
      case 2:
        img = require('@/assets/images/goodStyle-3.jpg')
        break
    }
    return img
  }

  mounted() {}

  /**
   * 选择商品信息
   */
  productsChange(e) {
    if (e) {
      e.forEach((item, index) => {
        if (
          this.ActivityConfig.list.indexOf(item.id) == -1 &&
          index < this.ActivityConfig.maxNumber &&
          this.ActivityConfig.list.length < this.ActivityConfig.maxNumber
        ) {
          this.ActivityConfig.list.push(item.id)
          this.ActivityConfig.products.push(item)
        }
      })
    }
  }

  activitySelect(e) {
    if (e) {
      this.ActivityConfig.activityId = e.id
      this.ActivityConfig.activityTitle = e.name
    }
  }

  clearFn() {
    this.ActivityConfig.activityId = null
    this.ActivityConfig.activityTitle = null
  }
   /**
   * 选择图片
   */
  picChange(e) {
    this.ActivityConfig.titleConfig.imgUrl = e[0].url
  }
}
